import { Button } from '@/ui/components/'
import { Badge } from '@/ui/components/'
import type { FeedCard as FeedCardType } from '@/shared/api'
import { FeedRow } from './FeedRow'
import { FEED_ICON_MAP } from './feedCardStyles'

interface EventCardProps {
  card: FeedCardType
}

function formatRange(start?: string, end?: string | null): string {
  if (!start) return ''
  const fmt = (d: string) => {
    const [y, m, day] = d.slice(0, 10).split('-').map(Number)
    return new Date(y, m - 1, day).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
  const startStr = fmt(start)
  if (!end || end.slice(0, 10) === start.slice(0, 10)) return startStr
  return `${startStr} – ${fmt(end)}`
}

/** Community event row (expos, rallies). Date · location in the subtitle, external link action. */
export function EventCard({ card }: EventCardProps) {
  const meta = card.metadata ?? {}
  const startDate = typeof meta.startDate === 'string' ? meta.startDate : undefined
  const endDate = typeof meta.endDate === 'string' ? meta.endDate : undefined
  const region = typeof meta.region === 'string' ? meta.region : undefined
  const dateRange = formatRange(startDate, endDate)

  const subtitle = (
    <>
      {[dateRange, region].filter(Boolean).join(' · ')}
      {(dateRange || region) && ' · '}
      {card.body}
    </>
  )

  return (
    <FeedRow
      title={card.title}
      subtitle={subtitle}
      icon={FEED_ICON_MAP[card.icon]}
      badge={<Badge variant="secondary">Event</Badge>}
      action={
        card.actionUrl && card.actionText ? (
          <Button variant="outline" size="sm" asChild>
            <a href={card.actionUrl} target="_blank" rel="noopener noreferrer">
              {card.actionText}
            </a>
          </Button>
        ) : undefined
      }
    />
  )
}
